import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";
import ViewField from "@/components/Input/ViewField";
import VLFModal from "@/components/Modal";

import {ProspectAPI} from "@/api/prospect";

import ArrowBack from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {SUCCESSFUL_OPERATION, ERROR_OPERATION} from "@/utils/constants";
import {useTranslation} from "react-i18next";

const ScoutClubPage = (props) => {
	const {handleNotification} = props;

	const navigate = useNavigate();
	const {id} = useParams();
	const {t} = useTranslation();

	const [loading, setLoading] = useState(false);
	const [club, setClub] = useState({});
	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);

	const getClub = async () => {
		setLoading(true);
		try {
			const response = await ProspectAPI.getByIdTeam(id);
			setClub(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};
	const deleteClub = async () => {
		setLoading(true);
		try {
			await ProspectAPI.deleteTeam(id);
			handleNotification(SUCCESSFUL_OPERATION, "success");
			navigate("/scout-clubs");
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
			setLoading(false);
		} finally {
			setOpenHandleConfirm(false);
		}
	};

	useEffect(() => {
		getClub();
	}, []);

	const goBack = () => {
		navigate("/scout-clubs");
	};

	const mainActions = [
		{icon: <ArrowBack />, title: "Indietro", onClick: goBack, color: "info"},
		{
			icon: <EditIcon />,
			title: "Modifica",
			onClick: () => navigate("/scout-clubs/" + club?.id + "/edit"),
		},
		{
			icon: <DeleteIcon />,
			title: "Elimina",
			onClick: () => setOpenHandleConfirm(true),
			color: "error",
		},
	];
	const mainConfiguration = [
		{
			value: club?.name,
			label: t("name"),
			size: "col-6 col-lg-4",
		},
		{
			value: club?.region,
			label: "Regione",
			size: "col-6 col-lg-4",
		},
		{
			value: club?.city,
			label: "Città",
			size: "col-6 col-lg-4",
		},
		{
			value: club?.district,
			label: "Provincia",
			size: "col-6 col-lg-4",
		},
		{
			value: club?.address,
			label: "Indirizzo",
			size: "col-6 col-lg-4",
		},
		{
			value: club?.notes,
			label: "Note",
			size: "col-6 col-lg-4",
		},
	];

	const breadcrumbsElements = [
		{label: "Club", path: "/scout-clubs"},
		{label: "/"},
	];

	return (
		<Page className="page-container">
			<Loading visible={loading} />
			<Breadcrumbs
				elements={breadcrumbsElements}
				current={club ? club.name : ""}
				actions={<MainActions actions={mainActions} />}
			/>
			<div className="sheet-container">
				<div className="row no-margin">
					<div className="col-sm-12 padding-small">
						<VLFCard
							title="Informazioni principali"
							content={
								<div className="row">
									<div className="col-sm-12 col-md-2">
										<div className="image-container generic">
											<img
												src={require("@/assets/images/manager/club.png")}
												alt=""
											/>
										</div>
									</div>
									<div className="col-sm-12 col-md-10">
										<ViewField configuration={mainConfiguration} />
									</div>
								</div>
							}
							openable={false}
						/>
					</div>
				</div>
				<VLFModal
					open={openHandleConfirm}
					title="Eliminazione"
					content={
						<div className="mt-2">
							Sei sicuro di voler eliminare questo elemento?
						</div>
					}
					confirm={() => {
						deleteClub();
					}}
					close={() => setOpenHandleConfirm(false)}
					confirmLabel="Conferma"
				/>
			</div>
		</Page>
	);
};

export default ScoutClubPage;
